import { toast } from 'react-toastify';
import { usersApi } from 'entities/users';
import { ChangeDataApiReqType, ChangeUserDataApiReqType } from 'features/changeUserData/types';

const changeUserDataApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    changeUserData: builder.mutation<any, ChangeUserDataApiReqType>({
      query: ({ id, body }) => ({
        url: `/account/admin/users/${id}/personal-data`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error: any, arg) => {
        if (error) {
          if (error.status === 422) {
            toast.error('Исправьте ошибки', {
              position: toast.POSITION.TOP_RIGHT,
            });
          } else {
            toast.error('Возникла непредвиденная ошибка. Пожалуйста, попробуйте еще раз', {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        } else {
          toast.success('Данные сохранены', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

const changeDataApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    changeData: builder.mutation<any, ChangeDataApiReqType>({
      query: ({ id, body }) => ({
        url: `/account/admin/users/${id}/user-data`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error: any, arg) => {
        const error_message = error?.data?.detail;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Данные сохранены', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const { useChangeUserDataMutation } = changeUserDataApi;

export const { useChangeDataMutation } = changeDataApi;
